import breakpoint from '@core/mixins/breakpoint.js';

export default {
    mixins: [breakpoint],

    computed: {
        productName() {
            const productName = this.productData?.parameters?.common?.productName;
            return productName ? `Acronis ${productName}` : '';
        },
    },

    methods: {
        logInteraction(button) {
            if (!this.isDesktop || !button.modal) return;
            const demoButtonClickDate = localStorage.getItem('demoButtonClickDate');
            if (!demoButtonClickDate) {
                localStorage.setItem('demoButtonClickDate', new Date());
            }
        },

        getButtonGA(button) {
            return {
                content: this.productName,
                ...button.event,
            };
        },

        getButtonType(buttons, index) {
            if (index === 0) {
                if (buttons.length === 1) return 'action';
                return 'main';
            }
            if (index === 1) {
                return 'action';
            }
            return 'secondary';
        },
    },
};
